// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main content styles */
ion-content {
  padding: 0 10px;
  --background: #f3f3f3 !important;
}

/* Header toolbar */
.toolbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background: white;
  align-items: center;
  box-shadow: 0px -4px 15px 0px rgba(13, 71, 161, 0.2509803922);
  /* Accessible button reset */
}
.toolbar .toolbar-button {
  background: transparent;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover styles */
  /* Active styles */
}
.toolbar .toolbar-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.toolbar .toolbar-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.toolbar .toolbar-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.toolbar .toolbar-button:active {
  transform: scale(0.95);
}
.toolbar .toolbar-button ion-icon {
  font-size: 24px;
  color: var(--ion-color-secondary);
}
.toolbar .title {
  margin: 0;
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
}

/* Promo info banner */
.promo-info {
  align-items: center;
  padding: 15px;
  background: white;
  margin: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  /* Improve visibility on focus */
}
.promo-info .name {
  width: 180px;
}
.promo-info:focus-within {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}

/* Minimum order notice */
.min-order {
  margin: 10px;
}

/* Add more button */
.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 10px;
  cursor: pointer;
  border-radius: 22px;
  background-color: var(--ion-color-primary);
  border: none;
  margin-top: 15px;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.add-more:focus {
  outline: 3px solid white;
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);
}
.add-more:focus-visible {
  outline: 3px solid white;
  outline-offset: 2px;
}
.add-more:hover {
  background-color: var(--ion-color-primary-shade);
}
.add-more:active {
  transform: scale(0.98);
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  color: white;
}
.add-more .add-button {
  margin-right: 12px;
}

/* Empty cart presentation */
.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Disabled button state */
.footer-button.invalid,
.footer-btn.invalid {
  --background: darkgrey;
  color: grey;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Main container */
.wrapper {
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
  background: #f3f3f3;
  background-size: cover;
}

/* Order list container */
.order-list {
  margin-block: 12px;
  width: 100%;
}

/* Article list presentation */
.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

/* Ordered articles section */
.ordered-articles {
  flex: 1;
  overflow-y: auto;
  padding: 16px 17px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f3f3f3;
  /* Improved scrollbar for accessibility */
  scrollbar-width: thin;
  scrollbar-color: var(--ion-color-primary) transparent;
}
.ordered-articles::-webkit-scrollbar {
  width: 8px;
}
.ordered-articles::-webkit-scrollbar-track {
  background: transparent;
}
.ordered-articles::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-primary);
  border-radius: 4px;
}

.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 13px;
}

/* Separator line */
.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

/* Error messages */
.promo-error,
.error-message {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: #b02424;
  font-weight: bold;
}

/* Empty cart message */
.no-articles {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.no-articles h3 {
  color: black;
  margin: 0;
}

/* Age verification checkbox */
.age-verified {
  color: var(--ion-color-primary);
  margin-bottom: 10px;
  background: #ffffff;
}
.age-verified ion-item {
  border: none;
  align-items: flex-start;
  /* Improve checkbox accessibility */
}
.age-verified ion-item ion-checkbox {
  --border-radius: 2px;
  --size: 20px;
}
.age-verified ion-item ion-checkbox:focus {
  --border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.age-verified ion-item label {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  cursor: pointer;
  padding: 2px 0;
}

/* Recommendations section */
.recommenation_section {
  padding: 10px;
  margin: 10px 0;
  width: 100%;
  /* Recommendation item card */
}
@media (max-width: 992px) {
  .recommenation_section {
    padding: 10px 20px;
  }
}
@media (max-width: 400px) {
  .recommenation_section {
    padding: 10px;
    margin: 6px 0;
  }
}
.recommenation_section .recom_title {
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  margin-left: 10px;
}
.recommenation_section .recommenation_section_articles {
  width: 100%;
}
.recommenation_section .recommenation_section_articles__item {
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0px 1.95px 7.3px 0px rgba(13, 71, 161, 0.1490196078);
  background: white;
  width: 100%;
  text-align: left;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover styles */
  /* Active styles */
  /* Add button within recommendation */
}
.recommenation_section .recommenation_section_articles__item:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.recommenation_section .recommenation_section_articles__item:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.recommenation_section .recommenation_section_articles__item:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
}
.recommenation_section .recommenation_section_articles__item:active {
  transform: translateY(1px);
}
.recommenation_section .recommenation_section_articles__item img {
  width: 120px;
  height: 60px;
  object-fit: contain;
  max-width: 200px;
  margin: 0 auto;
}
.recommenation_section .recommenation_section_articles__item .item-details {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.recommenation_section .recommenation_section_articles__item .item-details .left-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.recommenation_section .recommenation_section_articles__item .item-details .name {
  color: var(--ion-color-secondary);
  font-size: 13px;
  text-align: center;
  padding: 10px 5px;
  font-family: AppFontBold, sans-serif;
  margin-right: 5px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 40px;
  margin: 0;
}
.recommenation_section .recommenation_section_articles__item .add_button {
  width: 100%;
  border: 1px solid var(--ion-color-secondary);
  background: transparent;
  padding: 8px;
  border-radius: 10px;
  color: var(--ion-color-secondary);
  font-family: AppFontBold;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  cursor: pointer;
  /* Focus styles */
  /* Hover styles */
  /* Active styles */
}
.recommenation_section .recommenation_section_articles__item .add_button:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  background-color: rgba(0, 0, 0, 0.05);
}
.recommenation_section .recommenation_section_articles__item .add_button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.recommenation_section .recommenation_section_articles__item .add_button:active {
  background-color: rgba(0, 0, 0, 0.1);
}
.recommenation_section .recommenation_section_articles__item .price {
  text-align: right;
  padding: 5px 0;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  margin: 0;
}

/* Swiper container styles */
swiper-container {
  height: 100%;
}
swiper-container swiper-slide {
  margin: 0 10px;
}

/* Footer section */
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 17px;
  background: white;
  box-shadow: 0px -3px 45px 0px rgba(0, 0, 0, 0.1019607843);
  /* Price summary rows */
}
.footer .button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  /* Total price row */
  /* Checkout button */
}
.footer .button-row .sub-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.footer .button-row .sub-total .sub-total-title {
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .sub-total .sub-total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .border-line {
  width: 100%;
  height: 3px;
  margin-top: 13px;
}
.footer .button-row .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 19px;
}
.footer .button-row .total .total-title {
  font-family: AppFontBold;
  font-size: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .total .total-sum {
  font-family: AppFontBold;
  font-size: 18px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--ion-color-secondary);
  margin: 0;
}
.footer .button-row .footer-btn {
  margin-top: 12px;
  min-height: 46px;
  height: 46px;
  width: 100%;
  position: relative;
  padding: 5px;
  background: var(--ion-color-primary);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Disabled state */
}
.footer .button-row .footer-btn:focus {
  outline: 3px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);
}
.footer .button-row .footer-btn:focus-visible {
  outline: 3px solid var(--ion-color-primary-shade);
  outline-offset: 2px;
}
.footer .button-row .footer-btn:hover:not(:disabled) {
  background-color: var(--ion-color-primary-shade);
}
.footer .button-row .footer-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.footer .button-row .footer-btn:disabled, .footer .button-row .footer-btn.invalid {
  background-color: #cccccc;
  cursor: not-allowed;
}
.footer .button-row .footer-btn:disabled .footer-btn-text, .footer .button-row .footer-btn.invalid .footer-btn-text {
  color: #777777;
}
.footer .button-row .footer-btn .footer-btn-text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
  margin: 0;
}

/* Promo code section */
.add-promo-section {
  padding: 10px 0;
  width: 100%;
  /* Promo button */
}
.add-promo-section .wrapper-promo {
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 17px;
  overflow: hidden;
}
.add-promo-section .add-promo-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: var(--ion-color-primary);
  color: white;
  padding: 10px;
  width: 100%;
  border: none;
  cursor: pointer;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.add-promo-section .add-promo-block.border-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.add-promo-section .add-promo-block:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: -2px;
  box-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);
}
.add-promo-section .add-promo-block:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: -2px;
}
.add-promo-section .add-promo-block:hover {
  background-color: var(--ion-color-primary-shade);
}
.add-promo-section .add-promo-block:active {
  background-color: var(--ion-color-primary-tint);
}
.add-promo-section .add-promo-block ion-img {
  width: 20%;
}
.add-promo-section .add-promo-block .block-text {
  width: 70%;
  padding: 10px;
  text-align: left;
}
.add-promo-section .add-promo-block .block-text h3 {
  font-family: AppFontBold, sans-serif;
  color: white;
  font-size: 20px;
  margin: 0 0 5px 0;
}
.add-promo-section .add-promo-block .block-text p {
  color: white;
  font-size: 18px;
  margin: 0;
}
.add-promo-section .add-promo-block .chevron {
  width: 22px;
  height: 22px;
}

/* Applied promocode display */
.add-promocode-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
  padding: 10px 15px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  /* Promo code details */
  /* Remove promo button */
}
.add-promocode-wrapper ion-icon {
  width: 22px;
  height: 22px;
}
.add-promocode-wrapper .name-of-promo {
  display: flex;
  align-items: center;
  min-width: 60%;
  text-align: start;
  justify-content: space-between;
}
.add-promocode-wrapper .name-of-promo h2,
.add-promocode-wrapper .name-of-promo h3 {
  font-size: 16px;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
  margin: 0;
}
.add-promocode-wrapper .name-of-promo h3 {
  font-family: AppFontBold, sans-serif;
}
.add-promocode-wrapper .edit_section {
  display: flex;
  align-items: center;
}
.add-promocode-wrapper .edit_section .bsg-remove-promo {
  background: transparent;
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:focus {
  border: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:focus-visible {
  border: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.add-promocode-wrapper .edit_section .bsg-remove-promo:active {
  transform: scale(0.95);
}
.add-promocode-wrapper .edit_section .bsg-remove-promo ion-icon {
  height: 30px;
  width: 30px;
  color: #b02424;
}

/* High contrast mode enhancements */
.bsg-high-contrast {
  /* Enhanced button focus */
  /* Enhanced toolbar */
  /* Enhanced footer */
  /* Enhanced promo section */
  /* Enhanced recommendation items */
  /* Add more button */
  /* Enhanced error message */
}
.bsg-high-contrast button:focus {
  outline: 3px solid #0078d7 !important;
  outline-offset: 2px !important;
}
.bsg-high-contrast .toolbar {
  border-bottom: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .toolbar .toolbar-button ion-icon {
  color: black;
}
.bsg-high-contrast .toolbar .title {
  color: black;
}
.bsg-high-contrast .footer {
  border-top: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .footer .sub-total-title,
.bsg-high-contrast .footer .sub-total-sum,
.bsg-high-contrast .footer .total-title,
.bsg-high-contrast .footer .total-sum {
  color: black !important;
}
.bsg-high-contrast .footer .footer-btn {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .footer .footer-btn:disabled, .bsg-high-contrast .footer .footer-btn.invalid {
  background: #555555;
  border: 2px dashed black;
}
.bsg-high-contrast .add-promo-block {
  background: black !important;
  border: 2px solid white;
}
.bsg-high-contrast .add-promo-block .block-text h3,
.bsg-high-contrast .add-promo-block .block-text p {
  color: white !important;
}
.bsg-high-contrast .recommenation_section_articles__item {
  border: 2px solid black;
}
.bsg-high-contrast .recommenation_section_articles__item .name,
.bsg-high-contrast .recommenation_section_articles__item .price {
  color: black !important;
}
.bsg-high-contrast .recommenation_section_articles__item .add_button {
  border: 2px solid black;
  color: black !important;
}
.bsg-high-contrast .add-more {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .error-message {
  color: black !important;
  background: #ffcccc;
  border: 1px solid black;
  padding: 5px;
}

.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.add-promo-section {
  padding: 10px 0;
  width: 100%;
  /* Enhanced Promo button with better focus visibility */
  /* Applied promo code section styling */
  /* Enhanced remove promo button */
  /* High contrast mode support */
  /* Mobile touch improvements */
}
.add-promo-section .wrapper-promo {
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 17px;
  overflow: hidden;
  position: relative;
}
.add-promo-section .wrapper-promo:focus-within {
  box-shadow: 0 0 0 3px rgba(56, 128, 255, 0.3);
}
.add-promo-section .add-promo-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  background: var(--ion-color-primary);
  color: white;
  padding: 10px;
  width: 100%;
  border: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  outline: none;
  /* ENHANCED FOCUS STYLES - Much more visible */
  /* Alternative high-contrast focus style */
  /* Hover state - make sure it's different from focus */
  /* Active state */
  /* Disabled state if needed */
}
.add-promo-section .add-promo-block.border-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.add-promo-section .add-promo-block:focus, .add-promo-section .add-promo-block:focus-visible {
  outline: 3px solid white !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 6px var(--ion-color-primary-shade) !important;
  transform: scale(1.02);
  z-index: 10;
}
.add-promo-section .add-promo-block:focus-visible {
  box-shadow: inset 0 0 0 2px white, 0 0 0 4px var(--ion-color-warning, #ffc409), 0 4px 8px rgba(0, 0, 0, 0.2);
}
.add-promo-section .add-promo-block:hover:not(:focus) {
  background-color: var(--ion-color-primary-shade);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.add-promo-section .add-promo-block:active {
  background-color: var(--ion-color-primary-tint);
  transform: translateY(0);
  transition: all 0.1s ease;
}
.add-promo-section .add-promo-block:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.add-promo-section .add-promo-block:disabled:focus, .add-promo-section .add-promo-block:disabled:focus-visible {
  outline-color: var(--ion-color-medium);
  box-shadow: 0 0 0 3px rgba(150, 150, 150, 0.5);
}
.add-promo-section .add-promo-block ion-img {
  width: 20%;
  pointer-events: none;
}
.add-promo-section .add-promo-block .block-text {
  width: 70%;
  padding: 10px;
  text-align: left;
  pointer-events: none;
}
.add-promo-section .add-promo-block .block-text h3 {
  font-family: AppFontBold, sans-serif;
  color: white;
  font-size: 22px;
  margin: 0 0 5px 0;
  line-height: 1.2;
}
.add-promo-section .add-promo-block .block-text p {
  color: white;
  font-size: 18px;
  margin: 0;
  line-height: 1.3;
  opacity: 0.9;
}
.add-promo-section .add-promo-block .chevron {
  width: 22px;
  height: 22px;
  pointer-events: none;
  transition: transform 0.2s ease;
}
.add-promo-section .add-promo-block:focus .chevron, .add-promo-section .add-promo-block:focus-visible .chevron {
  transform: rotate(180deg);
}
.add-promo-section .add-promocode-wrapper {
  display: flex;
  align-items: center;
  padding: 12px;
  background: white;
  border-top: 1px solid rgba(var(--ion-color-primary-rgb), 0.2);
  gap: 12px;
}
.add-promo-section .add-promocode-wrapper .submit-button {
  width: 24px;
  height: 24px;
  color: var(--ion-color-success);
  flex-shrink: 0;
}
.add-promo-section .add-promocode-wrapper .name-of-promo {
  flex: 1;
}
.add-promo-section .add-promocode-wrapper .name-of-promo .name {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
  margin: 0 0 2px 0;
  line-height: 1.2;
}
.add-promo-section .add-promocode-wrapper .name-of-promo .discount {
  font-family: AppFontBold, sans-serif;
  font-size: 13px;
  color: var(--ion-color-secondary);
  margin: 0;
  line-height: 1.2;
}
.add-promo-section .add-promocode-wrapper .edit_section {
  flex-shrink: 0;
}
.add-promo-section .edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  outline: none;
  /* ENHANCED FOCUS STYLES for remove button */
}
.add-promo-section .edit-btn:focus, .add-promo-section .edit-btn:focus-visible {
  outline: 2px solid var(--ion-color-danger) !important;
  outline-offset: 2px !important;
  background: rgba(var(--ion-color-danger-rgb), 0.1);
  box-shadow: 0 0 0 4px rgba(var(--ion-color-danger-rgb), 0.2);
  transform: scale(1.1);
}
.add-promo-section .edit-btn:hover:not(:focus) {
  background: rgba(var(--ion-color-danger-rgb), 0.1);
  transform: scale(1.05);
}
.add-promo-section .edit-btn:active {
  background: rgba(var(--ion-color-danger-rgb), 0.2);
  transform: scale(1);
}
.add-promo-section .edit-btn ion-icon {
  width: 20px;
  height: 20px;
  color: var(--ion-color-danger);
  pointer-events: none;
}
.add-promo-section .edit-btn:focus::after, .add-promo-section .edit-btn:focus-visible::after {
  content: "Remove promo code";
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--ion-color-dark);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 100;
  opacity: 1;
  animation: fadeIn 0.2s ease;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
@media (prefers-contrast: high) {
  .add-promo-section .add-promo-block:focus, .add-promo-section .add-promo-block:focus-visible {
    outline: 4px solid yellow !important;
    outline-offset: 2px !important;
    box-shadow: 0 0 0 8px black, 0 0 0 12px yellow !important;
  }
  .add-promo-section .edit-btn:focus, .add-promo-section .edit-btn:focus-visible {
    outline: 3px solid red !important;
    background: yellow !important;
  }
  .add-promo-section .edit-btn:focus ion-icon, .add-promo-section .edit-btn:focus-visible ion-icon {
    color: red !important;
  }
}
@media (max-width: 768px) {
  .add-promo-section .add-promo-block {
    min-height: 48px;
  }
  .add-promo-section .add-promo-block:hover {
    transform: none;
  }
  .add-promo-section .edit-btn {
    min-width: 44px;
    min-height: 44px;
  }
  .add-promo-section .edit-btn:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADD;;AAIA,wBAAA;AACA;EACC,eAAA;EACA,gCAAA;AADD;;AAIA,mBAAA;AACA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,6DAAA;EAEA,4BAAA;AAFD;AAGC;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,iBAAA;EAKA,kBAAA;AAhBF;AAAE;EACC,2CAAA;EACA,mBAAA;AAEH;AAEE;EACC,2CAAA;EACA,mBAAA;AAAH;AAIE;EACC,qCAAA;AAFH;AAME;EACC,sBAAA;AAJH;AAOE;EACC,eAAA;EACA,iCAAA;AALH;AASC;EACC,SAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAPF;;AAWA,sBAAA;AACA;EACC,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,gCAAA;AAbD;AASC;EACC,YAAA;AAPF;AAWC;EACC,8CAAA;AATF;;AAaA,yBAAA;AACA;EACC,YAAA;AAVD;;AAaA,oBAAA;AACA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,gBAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AA1BD;AASC;EACC,wBAAA;EACA,mBAAA;EACA,6CAAA;AAPF;AAWC;EACC,wBAAA;EACA,mBAAA;AATF;AAaC;EACC,gDAAA;AAXF;AAeC;EACC,sBAAA;AAbF;AAgBC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAdF;AAiBC;EACC,kBAAA;AAfF;;AAmBA,4BAAA;AACA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAhBD;;AAmBA,0BAAA;AACA;;EAEC,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AAhBD;;AAmBA,mBAAA;AACA;EACC,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAhBD;;AAmBA,yBAAA;AACA;EACC,kBAAA;EACA,WAAA;AAhBD;;AAmBA,8BAAA;AACA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBD;AC7KE;EDwLF;IAQE,YAAA;EAfA;AACF;;AAkBA,6BAAA;AACA;EACC,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,qBAAA;EACA,qDAAA;AAhBD;AAkBC;EACC,UAAA;AAhBF;AAmBC;EACC,uBAAA;AAjBF;AAoBC;EACC,0CAAA;EACA,kBAAA;AAlBF;;AAsBA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAnBD;;AAsBA,mBAAA;AACA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAnBD;AAqBC;EACC,WAAA;EACA,yBAAA;AAnBF;AAsBC;EACC,yBAAA;AApBF;;AAwBA,mBAAA;AACA;;EAEC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AArBD;;AAwBA,uBAAA;AACA;EACC,aAAA;EACA,uBAAA;EACA,aAAA;AArBD;AAuBC;EACC,YAAA;EACA,SAAA;AArBF;;AAyBA,8BAAA;AACA;EACC,+BAAA;EACA,mBAAA;EACA,mBAAA;AAtBD;AAwBC;EACC,YAAA;EACA,uBAAA;EAEA,mCAAA;AAvBF;AAwBE;EACC,oBAAA;EACA,YAAA;AAtBH;AAwBG;EACC,wCAAA;EACA,8CAAA;AAtBJ;AA0BE;EACC,oCAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAxBH;;AA6BA,4BAAA;AACA;EACC,aAAA;EACA,cAAA;EACA,WAAA;EAsBA,6BAAA;AA/CD;ACxRE;ED8SF;IAME,kBAAA;EAxBA;AACF;AA0BC;EATD;IAUE,aAAA;IACA,aAAA;EAvBA;AACF;AAyBC;EACC,iCAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AAvBF;AA0BC;EACC,WAAA;AAxBF;AA4BC;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,gEAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qDACC;EAGD,iBAAA;EAOA,0BAAA;EAMA,iBAAA;EAMA,kBAAA;EA2CA,qCAAA;AAvFF;AA0BE;EACC,2CAAA;EACA,mBAAA;EACA,2CAAA;AAxBH;AA4BE;EACC,2CAAA;EACA,mBAAA;AA1BH;AA8BE;EACC,2BAAA;EACA,4CAAA;AA5BH;AAgCE;EACC,0BAAA;AA9BH;AAiCE;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA/BH;AAkCE;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;AAhCH;AAkCG;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAhCJ;AAmCG;EACC,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AAjCJ;AAsCE;EACC,WAAA;EACA,4CAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EAEA,iBAAA;EAOA,iBAAA;EAKA,kBAAA;AA/CH;AAoCG;EACC,2CAAA;EACA,mBAAA;EACA,qCAAA;AAlCJ;AAsCG;EACC,qCAAA;AApCJ;AAwCG;EACC,oCAAA;AAtCJ;AA0CE;EACC,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,iCAAA;EACA,SAAA;AAxCH;;AA6CA,4BAAA;AACA;EACC,YAAA;AA1CD;AA4CC;EACC,cAAA;AA1CF;;AA8CA,mBAAA;AACA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,yDAAA;EAEA,uBAAA;AA5CD;AA6CC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EAkCA,oBAAA;EA2BA,oBAAA;AAtGF;AA2CE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAzCH;AA2CG;EACC,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,SAAA;AAzCJ;AA4CG;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,SAAA;AA1CJ;AA8CE;EACC,WAAA;EACA,WAAA;EACA,gBAAA;AA5CH;AAgDE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AA9CH;AAgDG;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,SAAA;AA9CJ;AAiDG;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,SAAA;AA/CJ;AAoDE;EACC,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;EAEA,iBAAA;EAOA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,mBAAA;AAtEH;AAgDG;EACC,iDAAA;EACA,mBAAA;EACA,8CAAA;AA9CJ;AAkDG;EACC,iDAAA;EACA,mBAAA;AAhDJ;AAoDG;EACC,gDAAA;AAlDJ;AAsDG;EACC,0BAAA;AApDJ;AAwDG;EAEC,yBAAA;EACA,mBAAA;AAvDJ;AAyDI;EACC,cAAA;AAvDL;AA2DG;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAzDJ;;AA+DA,uBAAA;AACA;EACC,eAAA;EACA,WAAA;EAQA,iBAAA;AAnED;AA6DC;EACC,4CAAA;EACA,mBAAA;EACA,gBAAA;AA3DF;AA+DC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAOA,iBAAA;EAQA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AAnFF;AA2DE;EACC,4BAAA;EACA,6BAAA;AAzDH;AA6DE;EACC,2CAAA;EAEA,oBAAA;EACA,8CAAA;AA5DH;AAgEE;EACC,2CAAA;EACA,oBAAA;AA9DH;AAkEE;EACC,gDAAA;AAhEH;AAoEE;EACC,+CAAA;AAlEH;AAqEE;EACC,UAAA;AAnEH;AAsEE;EACC,UAAA;EACA,aAAA;EACA,gBAAA;AApEH;AAsEG;EACC,oCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AApEJ;AAuEG;EACC,YAAA;EACA,eAAA;EACA,SAAA;AArEJ;AAyEE;EACC,WAAA;EACA,YAAA;AAvEH;;AA4EA,8BAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,0CAAA;EACA,wDAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EAOA,uBAAA;EAqBA,wBAAA;AAnGD;AAyEC;EACC,WAAA;EACA,YAAA;AAvEF;AA2EC;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,8BAAA;AAzEF;AA2EE;;EAEC,eAAA;EACA,iCAAA;EACA,gCAAA;EACA,SAAA;AAzEH;AA4EE;EACC,oCAAA;AA1EH;AA+EC;EACC,aAAA;EACA,mBAAA;AA7EF;AA+EE;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;AA5FH;AA4EG;EACC,0CAAA;EACA,mBAAA;AA1EJ;AA8EG;EACC,0CAAA;EACA,mBAAA;AA5EJ;AAgFG;EACC,qCAAA;AA9EJ;AAkFG;EACC,sBAAA;AAhFJ;AAmFG;EACC,YAAA;EACA,WAAA;EACA,cAAA;AAjFJ;;AAuFA,oCAAA;AACA;EACC,0BAAA;EAMA,qBAAA;EAcA,oBAAA;EAwBA,2BAAA;EAWA,kCAAA;EAeA,oBAAA;EAMA,2BAAA;AA1JD;AA+EC;EACC,qCAAA;EACA,8BAAA;AA7EF;AAiFC;EACC,8BAAA;EACA,gBAAA;AA/EF;AAiFE;EACC,YAAA;AA/EH;AAkFE;EACC,YAAA;AAhFH;AAqFC;EACC,2BAAA;EACA,gBAAA;AAnFF;AAqFE;;;;EAIC,uBAAA;AAnFH;AAsFE;EACC,iBAAA;EACA,uBAAA;AApFH;AAsFG;EAEC,mBAAA;EACA,wBAAA;AArFJ;AA2FC;EACC,4BAAA;EACA,uBAAA;AAzFF;AA2FE;;EAEC,uBAAA;AAzFH;AA8FC;EACC,uBAAA;AA5FF;AA8FE;;EAEC,uBAAA;AA5FH;AA+FE;EACC,uBAAA;EACA,uBAAA;AA7FH;AAkGC;EACC,iBAAA;EACA,uBAAA;AAhGF;AAoGC;EACC,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAlGF;;AAuGA;EACC,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AApGD;;AAuGA;EACC,eAAA;EACA,WAAA;EAcA,uDAAA;EAkHA,uCAAA;EAyCA,iCAAA;EA2EA,+BAAA;EA0BA,8BAAA;AA7WD;AAiGC;EACC,4CAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA/FF;AAkGE;EACC,6CAAA;AAhGH;AAqGC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EAGA,aAAA;EAOA,8CAAA;EAaA,0CAAA;EASA,sDAAA;EAOA,iBAAA;EAOA,6BAAA;AA3IF;AAkGE;EACC,4BAAA;EACA,6BAAA;AAhGH;AAoGE;EAGC,mCAAA;EACA,8BAAA;EAEA,+DAAA;EAEA,sBAAA;EACA,WAAA;AAtGH;AA0GE;EAEC,4GACC;AA1GJ;AAgHE;EACC,gDAAA;EACA,2BAAA;EACA,yCAAA;AA9GH;AAkHE;EACC,+CAAA;EACA,wBAAA;EACA,yBAAA;AAhHH;AAoHE;EACC,YAAA;EACA,mBAAA;EACA,eAAA;AAlHH;AAoHG;EAEC,sCAAA;EACA,8CAAA;AAnHJ;AAuHE;EACC,UAAA;EACA,oBAAA;AArHH;AAwHE;EACC,UAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AAtHH;AAwHG;EACC,oCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAtHJ;AAyHG;EACC,YAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAvHJ;AA2HE;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,+BAAA;AAzHH;AA6HE;EAEC,yBAAA;AA5HH;AAiIC;EACC,aAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,6DAAA;EACA,SAAA;AA/HF;AAiIE;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;AA/HH;AAkIE;EACC,OAAA;AAhIH;AAkIG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;AAhIJ;AAmIG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;EACA,SAAA;EACA,gBAAA;AAjIJ;AAqIE;EACC,cAAA;AAnIH;AAwIC;EACC,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAGA,aAAA;EAEA,4CAAA;AAzIF;AA0IE;EAEC,qDAAA;EACA,8BAAA;EACA,kDAAA;EACA,4DAAA;EACA,qBAAA;AAzIH;AA4IE;EACC,kDAAA;EACA,sBAAA;AA1IH;AA6IE;EACC,kDAAA;EACA,mBAAA;AA3IH;AA8IE;EACC,WAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;AA5IH;AAgJE;EAEC,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;AA/IH;AAoJC;EACC;IACC,UAAA;IACA,4CAAA;EAlJD;EAoJA;IACC,UAAA;IACA,yCAAA;EAlJD;AACF;AAsJC;EAEE;IAEC,oCAAA;IACA,8BAAA;IACA,yDACC;EAvJH;EA6JC;IAEC,iCAAA;IACA,6BAAA;EA5JF;EA8JE;IACC,qBAAA;EA5JH;AACF;AAkKC;EACC;IACC,gBAAA;EAhKD;EAkKC;IACC,eAAA;EAhKF;EAoKA;IACC,eAAA;IACA,gBAAA;EAlKD;EAoKC;IACC,eAAA;EAlKF;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n/* Accessibility utilities */\n.visually-hidden {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n\n/* Main content styles */\nion-content {\n\tpadding: 0 10px;\n\t--background: #f3f3f3 !important;\n}\n\n/* Header toolbar */\n.toolbar {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px;\n\tbackground: white;\n\talign-items: center;\n\tbox-shadow: 0px -4px 15px 0px #0d47a140;\n\n\t/* Accessible button reset */\n\t.toolbar-button {\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\tpadding: 8px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tborder-radius: 50%;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Keyboard focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Hover styles */\n\t\t&:hover {\n\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t}\n\n\t\t/* Active styles */\n\t\t&:active {\n\t\t\ttransform: scale(0.95);\n\t\t}\n\n\t\tion-icon {\n\t\t\tfont-size: 24px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t}\n\n\t.title {\n\t\tmargin: 0;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 25px;\n\t\tline-height: 21px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: center;\n\t\tcolor: #000;\n\t}\n}\n\n/* Promo info banner */\n.promo-info {\n\talign-items: center;\n\tpadding: 15px;\n\tbackground: white;\n\tmargin: 10px;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\t/* Improve visibility on focus */\n\t&:focus-within {\n\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n\t}\n}\n\n/* Minimum order notice */\n.min-order {\n\tmargin: 10px;\n}\n\n/* Add more button */\n.add-more {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\theight: 34px;\n\tmin-width: fit-content;\n\tpadding: 10px;\n\tcursor: pointer;\n\tborder-radius: 22px;\n\tbackground-color: var(--ion-color-primary);\n\tborder: none;\n\tmargin-top: 15px;\n\n\t/* Focus styles */\n\t&:focus {\n\t\toutline: 3px solid white;\n\t\toutline-offset: 2px;\n\t\tbox-shadow: 0 0 0 4px rgba(113, 167, 97, 0.4);\n\t}\n\n\t/* Keyboard focus styles */\n\t&:focus-visible {\n\t\toutline: 3px solid white;\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Hover state */\n\t&:hover {\n\t\tbackground-color: var(--ion-color-primary-shade);\n\t}\n\n\t/* Active state */\n\t&:active {\n\t\ttransform: scale(0.98);\n\t}\n\n\t.add-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0px;\n\t\ttext-align: left;\n\t\tcolor: white;\n\t}\n\n\t.add-button {\n\t\tmargin-right: 12px;\n\t}\n}\n\n/* Empty cart presentation */\n.card-actions {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n/* Disabled button state */\n.footer-button.invalid,\n.footer-btn.invalid {\n\t--background: darkgrey;\n\tcolor: grey;\n\tcursor: not-allowed;\n\topacity: 0.7;\n}\n\n/* Main container */\n.wrapper {\n\tmax-height: 100%;\n\tflex-direction: column;\n\tdisplay: flex;\n\theight: 100%;\n\tbackground: #f3f3f3;\n\tbackground-size: cover;\n}\n\n/* Order list container */\n.order-list {\n\tmargin-block: 12px;\n\twidth: 100%;\n}\n\n/* Article list presentation */\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n/* Ordered articles section */\n.ordered-articles {\n\tflex: 1;\n\toverflow-y: auto;\n\tpadding: 16px 17px 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tbackground: #f3f3f3;\n\n\t/* Improved scrollbar for accessibility */\n\tscrollbar-width: thin;\n\tscrollbar-color: var(--ion-color-primary) transparent;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 8px;\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\tbackground: transparent;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--ion-color-primary);\n\t\tborder-radius: 4px;\n\t}\n}\n\n.ordered-articles-container {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin-bottom: 13px;\n}\n\n/* Separator line */\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-size: 7px 100%;\n\t}\n\n\t&--wide .line {\n\t\tbackground-size: 8px 100%;\n\t}\n}\n\n/* Error messages */\n.promo-error,\n.error-message {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: #b02424;\n\tfont-weight: bold;\n}\n\n/* Empty cart message */\n.no-articles {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 20px;\n\n\th3 {\n\t\tcolor: black;\n\t\tmargin: 0;\n\t}\n}\n\n/* Age verification checkbox */\n.age-verified {\n\tcolor: var(--ion-color-primary);\n\tmargin-bottom: 10px;\n\tbackground: #ffffff;\n\n\tion-item {\n\t\tborder: none;\n\t\talign-items: flex-start;\n\n\t\t/* Improve checkbox accessibility */\n\t\tion-checkbox {\n\t\t\t--border-radius: 2px;\n\t\t\t--size: 20px;\n\n\t\t\t&:focus {\n\t\t\t\t--border-color: var(--ion-color-primary);\n\t\t\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n\t\t\t}\n\t\t}\n\n\t\tlabel {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 2px 0;\n\t\t}\n\t}\n}\n\n/* Recommendations section */\n.recommenation_section {\n\tpadding: 10px;\n\tmargin: 10px 0;\n\twidth: 100%;\n\n\t@include mobile {\n\t\tpadding: 10px 20px;\n\t}\n\n\t@media (max-width: 400px) {\n\t\tpadding: 10px;\n\t\tmargin: 6px 0;\n\t}\n\n\t.recom_title {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 14px;\n\t\tmargin-left: 10px;\n\t}\n\n\t.recommenation_section_articles {\n\t\twidth: 100%;\n\t}\n\n\t/* Recommendation item card */\n\t.recommenation_section_articles__item {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tposition: relative;\n\t\tborder-radius: 10px;\n\t\tpadding: 10px;\n\t\tbox-shadow: 0px 1.95px 7.3px 0px #0d47a126;\n\t\tbackground: white;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\ttransition:\n\t\t\ttransform 0.2s ease,\n\t\t\tbox-shadow 0.2s ease;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t\tbox-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n\t\t}\n\n\t\t/* Keyboard focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Hover styles */\n\t\t&:hover {\n\t\t\ttransform: translateY(-2px);\n\t\t\tbox-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);\n\t\t}\n\n\t\t/* Active styles */\n\t\t&:active {\n\t\t\ttransform: translateY(1px);\n\t\t}\n\n\t\timg {\n\t\t\twidth: 120px;\n\t\t\theight: 60px;\n\t\t\tobject-fit: contain;\n\t\t\tmax-width: 200px;\n\t\t\tmargin: 0 auto;\n\t\t}\n\n\t\t.item-details {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: flex-start;\n\n\t\t\t.left-section {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\n\t\t\t.name {\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tfont-size: 13px;\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 10px 5px;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tmargin-right: 5px;\n\t\t\t\tword-break: break-word;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\toverflow: hidden;\n\t\t\t\theight: 40px;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\n\t\t/* Add button within recommendation */\n\t\t.add_button {\n\t\t\twidth: 100%;\n\t\t\tborder: 1px solid var(--ion-color-secondary);\n\t\t\tbackground: transparent;\n\t\t\tpadding: 8px;\n\t\t\tborder-radius: 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-family: AppFontBold;\n\t\t\ttext-align: center;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: 10px;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Focus styles */\n\t\t\t&:focus {\n\t\t\t\toutline: 2px solid var(--ion-color-primary);\n\t\t\t\toutline-offset: 2px;\n\t\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t\t}\n\n\t\t\t/* Hover styles */\n\t\t\t&:hover {\n\t\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t\t}\n\n\t\t\t/* Active styles */\n\t\t\t&:active {\n\t\t\t\tbackground-color: rgba(0, 0, 0, 0.1);\n\t\t\t}\n\t\t}\n\n\t\t.price {\n\t\t\ttext-align: right;\n\t\t\tpadding: 5px 0;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tmargin: 0;\n\t\t}\n\t}\n}\n\n/* Swiper container styles */\nswiper-container {\n\theight: 100%;\n\n\tswiper-slide {\n\t\tmargin: 0 10px;\n\t}\n}\n\n/* Footer section */\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: stretch;\n\tpadding: 17px;\n\tbackground: white;\n\tbox-shadow: 0px -3px 45px 0px #0000001a;\n\n\t/* Price summary rows */\n\t.button-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\n\t\t.sub-total {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 19px;\n\n\t\t\t.sub-total-title {\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: left;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.sub-total-sum {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: right;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\n\t\t.border-line {\n\t\t\twidth: 100%;\n\t\t\theight: 3px;\n\t\t\tmargin-top: 13px;\n\t\t}\n\n\t\t/* Total price row */\n\t\t.total {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 19px;\n\n\t\t\t.total-title {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: left;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.total-sum {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: right;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\n\t\t/* Checkout button */\n\t\t.footer-btn {\n\t\t\tmargin-top: 12px;\n\t\t\tmin-height: 46px;\n\t\t\theight: 46px;\n\t\t\twidth: 100%;\n\t\t\tposition: relative;\n\t\t\tpadding: 5px;\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tcolor: white;\n\t\t\tborder: none;\n\t\t\tborder-radius: 4px;\n\t\t\tcursor: pointer;\n\t\t\ttransition: background-color 0.2s ease;\n\n\t\t\t/* Focus styles */\n\t\t\t&:focus {\n\t\t\t\toutline: 3px solid var(--ion-color-primary-shade);\n\t\t\t\toutline-offset: 2px;\n\t\t\t\tbox-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);\n\t\t\t}\n\n\t\t\t/* Keyboard focus styles */\n\t\t\t&:focus-visible {\n\t\t\t\toutline: 3px solid var(--ion-color-primary-shade);\n\t\t\t\toutline-offset: 2px;\n\t\t\t}\n\n\t\t\t/* Hover state */\n\t\t\t&:hover:not(:disabled) {\n\t\t\t\tbackground-color: var(--ion-color-primary-shade);\n\t\t\t}\n\n\t\t\t/* Active state */\n\t\t\t&:active:not(:disabled) {\n\t\t\t\ttransform: translateY(1px);\n\t\t\t}\n\n\t\t\t/* Disabled state */\n\t\t\t&:disabled,\n\t\t\t&.invalid {\n\t\t\t\tbackground-color: #cccccc;\n\t\t\t\tcursor: not-allowed;\n\n\t\t\t\t.footer-btn-text {\n\t\t\t\t\tcolor: #777777;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.footer-btn-text {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 14px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: #fff;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Promo code section */\n.add-promo-section {\n\tpadding: 10px 0;\n\twidth: 100%;\n\n\t.wrapper-promo {\n\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\tborder-radius: 17px;\n\t\toverflow: hidden;\n\t}\n\n\t/* Promo button */\n\t.add-promo-block {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-radius: 20px;\n\t\tbackground: var(--ion-color-primary);\n\t\tcolor: white;\n\t\tpadding: 10px;\n\t\twidth: 100%;\n\t\tborder: none;\n\t\tcursor: pointer;\n\n\t\t&.border-bottom {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\n\t\t\toutline-offset: -2px;\n\t\t\tbox-shadow: 0 0 0 4px rgba(113, 167, 97, 0.25);\n\t\t}\n\n\t\t/* Keyboard focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: -2px;\n\t\t}\n\n\t\t/* Hover state */\n\t\t&:hover {\n\t\t\tbackground-color: var(--ion-color-primary-shade);\n\t\t}\n\n\t\t/* Active state */\n\t\t&:active {\n\t\t\tbackground-color: var(--ion-color-primary-tint);\n\t\t}\n\n\t\tion-img {\n\t\t\twidth: 20%;\n\t\t}\n\n\t\t.block-text {\n\t\t\twidth: 70%;\n\t\t\tpadding: 10px;\n\t\t\ttext-align: left;\n\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tmargin: 0 0 5px 0;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\n\t\t.chevron {\n\t\t\twidth: 22px;\n\t\t\theight: 22px;\n\t\t}\n\t}\n}\n\n/* Applied promocode display */\n.add-promocode-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground: white;\n\tborder-radius: var(--custom-border-radius);\n\tbox-shadow: 0px 0px 42px 0px #00000012;\n\tpadding: 10px 15px;\n\tborder-top-right-radius: 0;\n\tborder-top-left-radius: 0;\n\n\tion-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t}\n\n\t/* Promo code details */\n\t.name-of-promo {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmin-width: 60%;\n\t\ttext-align: start;\n\t\tjustify-content: space-between;\n\n\t\th2,\n\t\th3 {\n\t\t\tfont-size: 16px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tmargin: 0;\n\t\t}\n\n\t\th3 {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t}\n\t}\n\n\t/* Remove promo button */\n\t.edit_section {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.bsg-remove-promo {\n\t\t\tbackground: transparent;\n\t\t\tborder: none;\n\t\t\tpadding: 8px;\n\t\t\tborder-radius: 50%;\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t/* Focus styles */\n\t\t\t&:focus {\n\t\t\t\tborder: 2px solid var(--ion-color-primary);\n\t\t\t\toutline-offset: 2px;\n\t\t\t}\n\n\t\t\t/* Keyboard focus styles */\n\t\t\t&:focus-visible {\n\t\t\t\tborder: 2px solid var(--ion-color-primary);\n\t\t\t\toutline-offset: 2px;\n\t\t\t}\n\n\t\t\t/* Hover state */\n\t\t\t&:hover {\n\t\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t\t}\n\n\t\t\t/* Active state */\n\t\t\t&:active {\n\t\t\t\ttransform: scale(0.95);\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\theight: 30px;\n\t\t\t\twidth: 30px;\n\t\t\t\tcolor: #b02424;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n\t/* Enhanced button focus */\n\tbutton:focus {\n\t\toutline: 3px solid #0078d7 !important;\n\t\toutline-offset: 2px !important;\n\t}\n\n\t/* Enhanced toolbar */\n\t.toolbar {\n\t\tborder-bottom: 2px solid black;\n\t\tbox-shadow: none;\n\n\t\t.toolbar-button ion-icon {\n\t\t\tcolor: black;\n\t\t}\n\n\t\t.title {\n\t\t\tcolor: black;\n\t\t}\n\t}\n\n\t/* Enhanced footer */\n\t.footer {\n\t\tborder-top: 2px solid black;\n\t\tbox-shadow: none;\n\n\t\t.sub-total-title,\n\t\t.sub-total-sum,\n\t\t.total-title,\n\t\t.total-sum {\n\t\t\tcolor: black !important;\n\t\t}\n\n\t\t.footer-btn {\n\t\t\tbackground: black;\n\t\t\tborder: 2px solid white;\n\n\t\t\t&:disabled,\n\t\t\t&.invalid {\n\t\t\t\tbackground: #555555;\n\t\t\t\tborder: 2px dashed black;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Enhanced promo section */\n\t.add-promo-block {\n\t\tbackground: black !important;\n\t\tborder: 2px solid white;\n\n\t\t.block-text h3,\n\t\t.block-text p {\n\t\t\tcolor: white !important;\n\t\t}\n\t}\n\n\t/* Enhanced recommendation items */\n\t.recommenation_section_articles__item {\n\t\tborder: 2px solid black;\n\n\t\t.name,\n\t\t.price {\n\t\t\tcolor: black !important;\n\t\t}\n\n\t\t.add_button {\n\t\t\tborder: 2px solid black;\n\t\t\tcolor: black !important;\n\t\t}\n\t}\n\n\t/* Add more button */\n\t.add-more {\n\t\tbackground: black;\n\t\tborder: 2px solid white;\n\t}\n\n\t/* Enhanced error message */\n\t.error-message {\n\t\tcolor: black !important;\n\t\tbackground: #ffcccc;\n\t\tborder: 1px solid black;\n\t\tpadding: 5px;\n\t}\n}\n\n// Utility class for screen readers\n.visually-hidden {\n\tposition: absolute !important;\n\twidth: 1px !important;\n\theight: 1px !important;\n\tpadding: 0 !important;\n\tmargin: -1px !important;\n\toverflow: hidden !important;\n\tclip: rect(0, 0, 0, 0) !important;\n\twhite-space: nowrap !important;\n\tborder: 0 !important;\n}\n\n.add-promo-section {\n\tpadding: 10px 0;\n\twidth: 100%;\n\n\t.wrapper-promo {\n\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\tborder-radius: 17px;\n\t\toverflow: hidden;\n\t\tposition: relative;\n\n\t\t// Enhanced wrapper focus-within state\n\t\t&:focus-within {\n\t\t\tbox-shadow: 0 0 0 3px rgba(56, 128, 255, 0.3);\n\t\t}\n\t}\n\n\t/* Enhanced Promo button with better focus visibility */\n\t.add-promo-block {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tborder-radius: 16px;\n\t\tbackground: var(--ion-color-primary);\n\t\tcolor: white;\n\t\tpadding: 10px;\n\t\twidth: 100%;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition: all 0.2s ease;\n\n\t\t// Remove default button outline\n\t\toutline: none;\n\n\t\t&.border-bottom {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* ENHANCED FOCUS STYLES - Much more visible */\n\t\t&:focus,\n\t\t&:focus-visible {\n\t\t\t// White outline that contrasts with primary color background\n\t\t\toutline: 3px solid white !important;\n\t\t\toutline-offset: 2px !important;\n\t\t\t// Additional box shadow for extra visibility\n\t\t\tbox-shadow: 0 0 0 6px var(--ion-color-primary-shade) !important;\n\t\t\t// Slight scale for attention\n\t\t\ttransform: scale(1.02);\n\t\t\tz-index: 10;\n\t\t}\n\n\t\t/* Alternative high-contrast focus style */\n\t\t&:focus-visible {\n\t\t\t// Double outline effect\n\t\t\tbox-shadow:\n\t\t\t\tinset 0 0 0 2px white,\n\t\t\t\t0 0 0 4px var(--ion-color-warning, #ffc409),\n\t\t\t\t0 4px 8px rgba(0, 0, 0, 0.2);\n\t\t}\n\n\t\t/* Hover state - make sure it's different from focus */\n\t\t&:hover:not(:focus) {\n\t\t\tbackground-color: var(--ion-color-primary-shade);\n\t\t\ttransform: translateY(-1px);\n\t\t\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n\t\t}\n\n\t\t/* Active state */\n\t\t&:active {\n\t\t\tbackground-color: var(--ion-color-primary-tint);\n\t\t\ttransform: translateY(0);\n\t\t\ttransition: all 0.1s ease;\n\t\t}\n\n\t\t/* Disabled state if needed */\n\t\t&:disabled {\n\t\t\topacity: 0.6;\n\t\t\tcursor: not-allowed;\n\t\t\ttransform: none;\n\n\t\t\t&:focus,\n\t\t\t&:focus-visible {\n\t\t\t\toutline-color: var(--ion-color-medium);\n\t\t\t\tbox-shadow: 0 0 0 3px rgba(150, 150, 150, 0.5);\n\t\t\t}\n\t\t}\n\n\t\tion-img {\n\t\t\twidth: 20%;\n\t\t\tpointer-events: none; // Prevent image from interfering with button clicks\n\t\t}\n\n\t\t.block-text {\n\t\t\twidth: 70%;\n\t\t\tpadding: 10px;\n\t\t\ttext-align: left;\n\t\t\tpointer-events: none; // Prevent text from interfering with button clicks\n\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 22px;\n\t\t\t\tmargin: 0 0 5px 0;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tcolor: white;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.3;\n\t\t\t\topacity: 0.9;\n\t\t\t}\n\t\t}\n\n\t\t.chevron {\n\t\t\twidth: 22px;\n\t\t\theight: 22px;\n\t\t\tpointer-events: none;\n\t\t\ttransition: transform 0.2s ease;\n\t\t}\n\n\t\t// Rotate chevron when focused for visual feedback\n\t\t&:focus .chevron,\n\t\t&:focus-visible .chevron {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\n\t/* Applied promo code section styling */\n\t.add-promocode-wrapper {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 12px;\n\t\tbackground: white;\n\t\tborder-top: 1px solid rgba(var(--ion-color-primary-rgb), 0.2);\n\t\tgap: 12px;\n\n\t\t.submit-button {\n\t\t\twidth: 24px;\n\t\t\theight: 24px;\n\t\t\tcolor: var(--ion-color-success);\n\t\t\tflex-shrink: 0;\n\t\t}\n\n\t\t.name-of-promo {\n\t\t\tflex: 1;\n\n\t\t\t.name {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tmargin: 0 0 2px 0;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n\n\t\t\t.discount {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n\t\t}\n\n\t\t.edit_section {\n\t\t\tflex-shrink: 0;\n\t\t}\n\t}\n\n\t/* Enhanced remove promo button */\n\t.edit-btn {\n\t\tbackground: none;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\tpadding: 8px;\n\t\tborder-radius: 50%;\n\t\ttransition: all 0.2s ease;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\n\t\t// Remove default outline\n\t\toutline: none;\n\n\t\t/* ENHANCED FOCUS STYLES for remove button */\n\t\t&:focus,\n\t\t&:focus-visible {\n\t\t\toutline: 2px solid var(--ion-color-danger) !important;\n\t\t\toutline-offset: 2px !important;\n\t\t\tbackground: rgba(var(--ion-color-danger-rgb), 0.1);\n\t\t\tbox-shadow: 0 0 0 4px rgba(var(--ion-color-danger-rgb), 0.2);\n\t\t\ttransform: scale(1.1);\n\t\t}\n\n\t\t&:hover:not(:focus) {\n\t\t\tbackground: rgba(var(--ion-color-danger-rgb), 0.1);\n\t\t\ttransform: scale(1.05);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: rgba(var(--ion-color-danger-rgb), 0.2);\n\t\t\ttransform: scale(1);\n\t\t}\n\n\t\tion-icon {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tcolor: var(--ion-color-danger);\n\t\t\tpointer-events: none;\n\t\t}\n\n\t\t// Tooltip on focus\n\t\t&:focus::after,\n\t\t&:focus-visible::after {\n\t\t\tcontent: 'Remove promo code';\n\t\t\tposition: absolute;\n\t\t\ttop: -35px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tbackground: var(--ion-color-dark);\n\t\t\tcolor: white;\n\t\t\tpadding: 4px 8px;\n\t\t\tborder-radius: 4px;\n\t\t\tfont-size: 12px;\n\t\t\twhite-space: nowrap;\n\t\t\tz-index: 100;\n\t\t\topacity: 1;\n\t\t\tanimation: fadeIn 0.2s ease;\n\t\t}\n\t}\n\n\t// Fade in animation for tooltip\n\t@keyframes fadeIn {\n\t\tfrom {\n\t\t\topacity: 0;\n\t\t\ttransform: translateX(-50%) translateY(-5px);\n\t\t}\n\t\tto {\n\t\t\topacity: 1;\n\t\t\ttransform: translateX(-50%) translateY(0);\n\t\t}\n\t}\n\n\t/* High contrast mode support */\n\t@media (prefers-contrast: high) {\n\t\t.add-promo-block {\n\t\t\t&:focus,\n\t\t\t&:focus-visible {\n\t\t\t\toutline: 4px solid yellow !important;\n\t\t\t\toutline-offset: 2px !important;\n\t\t\t\tbox-shadow:\n\t\t\t\t\t0 0 0 8px black,\n\t\t\t\t\t0 0 0 12px yellow !important;\n\t\t\t}\n\t\t}\n\n\t\t.edit-btn {\n\t\t\t&:focus,\n\t\t\t&:focus-visible {\n\t\t\t\toutline: 3px solid red !important;\n\t\t\t\tbackground: yellow !important;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tcolor: red !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Mobile touch improvements */\n\t@media (max-width: 768px) {\n\t\t.add-promo-block {\n\t\t\tmin-height: 48px; // Minimum touch target\n\n\t\t\t&:hover {\n\t\t\t\ttransform: none; // Disable hover transform on mobile\n\t\t\t}\n\t\t}\n\n\t\t.edit-btn {\n\t\t\tmin-width: 44px;\n\t\t\tmin-height: 44px;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
